import React from 'react'

// Styles
import styles from '../styles/Spinner.scss'

const Spinner: React.FC = () => {
  return (
    <div className={styles.spinner} />
  )
}

export default Spinner
